import React from "react";

import ConfirmModal from "./ConfirmModal";
import MultiSelectButtons from "./MultiSelectButtons";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";
import "./index.css";
import CsnModal from "./CsnModal";
import ViewAdtModal from "./ViewAdtModal";
import AdtSidebar from "../../Adts/AdtSidebar/AdtSidebar";
import useHl7JobsTable from "../hooks/useHl7Jobs";

const Hl7JobsTable = ({ alertType, setAlertType }) => {
  const {
    dataRow,
    operation,
    isLoading,
    showEditCsn,
    showAdtModal,
    showConfirmModal,
    selectedRowsData,
    selectedRowsCount,
    showAdtSidebar,

    closeAdtModal,
    closeConfirmModal,
    closeCsnModal,
    handleConfirmModal,
    setShowAdtSidebar,

    handleRetry,
    getHl7TableData,
    handleUpdateJob,

    hl7JobsTableMemo,
  } = useHl7JobsTable(alertType, setAlertType);

  return (
    <>
      <CsnModal
        anchorEl={showEditCsn}
        dataRow={dataRow}
        close={closeCsnModal}
        update={handleUpdateJob}
        isLoading={isLoading}
      />
      {showAdtModal && (
        <ViewAdtModal
          show={showAdtModal}
          dataRow={dataRow}
          close={closeAdtModal}
        />
      )}

      <ConfirmModal
        retry={handleRetry}
        dataRow={dataRow}
        op={operation}
        close={closeConfirmModal}
        show={showConfirmModal}
      />

      <div
        style={{
          position: "absolute",
          top: "110px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1000,
        }}
      >
        <MultiSelectButtons
          selectedRowsCount={selectedRowsCount}
          selectedRowsData={selectedRowsData}
          handleConfirmModal={handleConfirmModal}
        />
      </div>

      <div
        style={{
          position: "absolute",
          top: "100px",
          right: "28px",
          zIndex: 1000,
        }}
      >
        <Tooltip title={"Reload"}>
          <Button
            onClick={getHl7TableData}
            variant="contained"
            style={{ backgroundColor: "#94ba33" }}
          >
            <RefreshIcon style={{ color: "white" }} />
          </Button>
        </Tooltip>
      </div>

      <div style={{ height: "calc(100vh - 160px)", overflow: "auto" }}>
        {hl7JobsTableMemo}
      </div>

      {showAdtSidebar && (
        <AdtSidebar
          open={showAdtSidebar}
          onClose={() => setShowAdtSidebar(false)}
        />
      )}
    </>
  );
};

export default React.memo(Hl7JobsTable);
